import type { PropTypesSectionAchievements } from "@front/components/Section/Achievements/types";
import type { PropTypesActionsButtonsSection } from "@front/components/Section/ActionButtons/types";
import type { PropTypesVerticalCardsSection } from "@front/components/Section/Card/Vertical/types";

export const DATA_CRACK_CHALLENGE: PropTypesActionsButtonsSection = {
    title: "options-about",
    "uuid-bold": "subtitle-mindset",
    "uuid-section": "test-crack-name-2",
    isFavorite: false,
    desc: "test-review-comment",
    onClickSave() {},
    onClickShare() {},
    onClickLike() {},
    onClickDislike() {},
    "preset-bold": "yacuiba",
};

export const DATA_VERTIVCALCARDS_CHALLENGE: PropTypesVerticalCardsSection = {
    hasTitle: true,
    title: "challenges-subtitle",
    cards: [
        {
            bitmap: "rafa-marquez-challenge-hit-crossbar",
            title: "crack-rafa-marquez-challenge-hit-crossbar-title",
            "title-preset": "reynosa",
            preset: "challenge",
            href: "/signup",
            id: "rafa-marquez",
            hasFade: false,
        },
        {
            bitmap: "carlos-salcido-challege-motorcycle",
            title: "crack-carlos-salcido-challege-motorcycle-title",
            "title-preset": "reynosa",
            preset: "challenge",
            href: "/signup",
            id: "carlos-salcido",
            hasFade: false,
        },
        {
            bitmap: "gigi-buffon-challenge-juggles",
            title: "crack-gigi-buffon-challenge-juggles-title",
            "title-preset": "reynosa",
            preset: "challenge",
            href: "/signup",
            id: "gianluigi-buffon",
            hasFade: false,
        },
        {
            bitmap: "charlyn-corral-challege-hump-arround-wolrd",
            title: "crack-charlyn-corral-challege-hump-arround-wolrd-title",
            "title-preset": "reynosa",
            preset: "challenge",
            href: "/signup",
            id: "charlyn-corral",
        },
        {
            bitmap: "pavel-pardo-challenge-20-kick-ups",
            title: "crack-pavel-pardo-challenge-20-kick-ups-title",
            "title-preset": "reynosa",
            preset: "challenge",
            href: "/signup",
            id: "pavel-pardo",
            hasFade: false,
        },
        {
            bitmap: "carlos-salcido-challege-sit-down-kick-ups",
            title: "crack-carlos-salcido-challege-sit-down-kick-ups-title",
            "title-preset": "reynosa",
            preset: "challenge",
            href: "/signup",
            id: "carlos-salcido",
            hasFade: false,
        },
        {
            bitmap: "jared-borgetti-challenge-fake-headshot",
            title: "crack-jared-borgetti-challenge-fake-headshot-title",
            "title-preset": "reynosa",
            preset: "challenge",
            href: "/signup",
            id: "jared-borgetti",
            hasFade: false,
        },
        {
            bitmap: "charlyn-corral-challege-neck-stall-push-ups",
            title: "crack-charlyn-corral-challege-neck-stall-push-ups-title",
            "title-preset": "reynosa",
            preset: "challenge",
            href: "/signup",
            id: "charlyn-corral",
            hasFade: false,
        },
    ],
};

export const DATA_ACHIVEMENTS_CHALLENGE: PropTypesSectionAchievements = {
    title: "challenges-description-3",
    medals: ["medal-a", "medal-b", "medal-c", "medal-d", "medal-e", "medal-f"],
    bitmaps: ["screenshot-challenge-1", "screenshot-challenge-2", "screenshot-challenge-3"],
};
